<template>
  <div class="ccui-app-container">
    <div class="top">
      <el-search
        :formProp="formData"
        @resetForm="resetForm"
        :selectClear="true"
        :spoNum="3"
        width="400px"
        @search="search"
      >
        <div class="ccui-advanced-search-wrapper ccui-clearfix my-tab">
          <el-button
            class="tab"
            @click="tabChange(item)"
            v-for="item in tabButton"
            :key="item.focus"
            :type="tabShow === item.focus ? 'table-top-active' : 'table-top'"
            size="mini"
            >{{ item.label
            }}{{ tabShow === item.focus ? `(${totalNum})` : "" }}</el-button
          >
        </div>
        <template slot="search">
          <el-input
            v-model.trim="formData.seekCode"
            clearable
            placeholder="请输入询价单号精确查询"
            searchLabel="询价单号"
          ></el-input>
          <el-input
            v-model.trim="formData.seekTitle"
            clearable
            placeholder="请输入询价标题模糊查询"
            searchLabel="询价标题"
          ></el-input>
          <el-input
            v-model.trim="formData.purchaseOrgName"
            clearable
            placeholder="请输入采购单位模糊查询"
            searchLabel="采购单位"
          ></el-input>
          <el-date-picker
            v-model="formData.seekendDate"
            searchLabel="报价截止时间"
            clearable
            type="daterange"
            placeholder="请选择报价截止时间"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
          <el-select
            v-if="tabShow === 'offer'"
            v-model="formData.supplierCheckedStatus"
            clearable
            searchLabel="结果"
            placeholder="请选择"
          >
            <el-option
              v-for="item in optionsLists"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>

        <el-input
          slot="searchItem1"
          v-model.trim="formData.seekCode"
          clearable
          placeholder="请输入询价单号精确查询"
          searchLabel="询价单号"
        ></el-input>
        <el-input
          slot="searchItem2"
          v-model.trim="formData.seekTitle"
          clearable
          placeholder="请输入询价标题模糊查询"
          searchLabel="询价标题"
        ></el-input>
        <el-input
          slot="searchItem3"
          v-model.trim="formData.purchaseOrgName"
          clearable
          placeholder="请输入采购单位模糊查询"
          searchLabel="采购单位"
        ></el-input>
        <el-date-picker
          slot="searchItem4"
          v-model="formData.seekendDate"
          searchLabel="报价截止时间"
          clearable
          type="daterange"
          placeholder="请选择报价截止时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
        <el-select
          v-if="tabShow === 'offer'"
          slot="searchItem5"
          v-model="formData.supplierCheckedStatus"
          clearable
          searchLabel="结果"
          placeholder="请选择"
        >
          <el-option
            v-for="item in optionsLists"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-search>
    </div>
    <div class="ccui-multifunctional-table-wrapper">
      <el-table
        v-if="tableHack"
        ref="multipleTable"
        v-loading="loading"
        :data="tableData"
        :fit="true"
        @cell-click="cellClick"
        :cell-style="cellStyle"
        border
        class="ccui-multifunctional-table"
        @header-dragend="tableTitleWidth"
        @selection-change="handleSelectionChange"
        :min-height="9999"
        :max-height="99999"
      >
        <el-table-column fixed="left" label="序号" type="index" width="50" />
        <el-table-column
          v-if="tabShow === 'offer'"
          label="询价单编号"
          align="left"
          min-width="170px"
          fixed="left"
        >
          <template slot-scope="{ row }">
            <span>{{ row.seekCode }}</span>
            <div
              v-if="
                (row.isChecked === 0 && row.seekType === 3) ||
                  (row.isChecked === 1 && row.seekType === 3)
              "
              :class="row.isChecked === 0 ? 'unIsSelect' : 'isSelect'"
            >
              {{
                row.isChecked === 0
                  ? "未选中"
                  : row.isChecked === 1
                  ? "选中"
                  : ""
              }}
            </div>
          </template>
        </el-table-column>
        <template v-for="(table, index) in tableTheadOptions">
          <el-table-column
            v-if="table.checked"
            :fixed="table.fixed || false"
            :type="table.type"
            :key="index"
            :label="table.label"
            :min-width="table.width"
            :prop="table.prop"
            :filters="table.filters"
            :align="table.align"
            :header-align="table.headerAlign || 'left'"
            :formatter="table.formatter"
            :show-overflow-tooltip="true"
          >
            <template #default="{ row }">
              <span
                v-html="formatCellContent(row, table.prop, table.type)"
              ></span>
            </template>
          </el-table-column>
        </template>
        <el-table-column label="操作" :width="120" fixed="right">
          <template slot-scope="{ row }">
            <el-button
              size="mini"
              v-for="e in filteredOptions(row)"
              :key="e.value"
              type="text"
              @click="handleClick(row, e.value)"
            >
              {{ e.label }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="ccui-table-footer" v-if="totalNum > 0">
        <div id="ccui-paging">
          <el-pagination
            :total="totalNum"
            :page-size="getLocalPageSize()"
            :current-page="formDataSearch.pageNo"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSessionItem } from "@/config/utils";
export default {
  name: "quotationTable",
  props: {
    tabShow: String,
    totalNum: Number,
    // 表格数据
    tableData: Array,
    loading: Boolean,
    unfixedTableThead: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tabButton: [
        // { focus: "pending", label: "待报价" },
        { focus: "offer", label: "已报价" },
        { focus: "lose", label: "已失效" }
      ],
      optionsLists: [
        {
          value: "1",
          label: "全部中标"
        },
        {
          value: "2",
          label: "部分中标"
        },
        {
          value: "0",
          label: "未中标"
        },
        {
          value: "-1",
          label: "待定标"
        }
      ],
      tableHack: true,
      tableTheadOptions: [],
      tableSelectLists: [],
      formData: {
        pageNo: 1,
        pageSize: this.getLocalPageSize(),
        isShowPageLoading: false
      },
      formDataSearch: {
        pageNo: 1,
        pageSize: this.getLocalPageSize(),
        isShowPageLoading: true
      },
      // 表格数据
      tableThead: [],
      tableName: "inquiryForm",
      fixedTableThead: [],
      options: [
        {
          value: 1,
          label: "报价"
        },
        {
          value: 2,
          label: "查看"
        },
        {
          value: 3,
          label: "再次报价"
        }
      ]
    };
  },
  activated() {
    this.tableTheadOptions = this.fixedTableThead.concat(
      this.unfixedTableThead
    );
    this.getList(this.formDataSearch);
  },
  methods: {
    formatCellContent(row, prop, type) {
      const cellValue = row[prop];
      switch (type) {
        case "time":
          return cellValue ? cellValue.substring(0, 10) : "-";

        case "isOff":
          return cellValue === 0 ? "否" : cellValue === 1 ? "是" : "-";
        case "supplierCheckedStatus":
          return cellValue === 0 && row.isOff === 1
            ? "未中标"
            : cellValue === 1
            ? "全部中标"
            : cellValue === 2
            ? "部分中标"
            : cellValue === -1
            ? "待定标"
            : "-";

        // 新增的东西
        case "sourceSystem":
          return cellValue === 1 ? "二级集采" : cellValue === 2 ? "租赁" : "-";

        case "num":
          return cellValue.toFixed(2);

        default:
          return cellValue || "-";
      }
    },
    tabChange(item) {
      this.$router.push(`/inquiry/inquiryLists/${item.focus}`);
    },
    search(searchData) {
      console.log("🚀 ~ search ~ searchData:", searchData);
      this.formData.pageNo = 1;
      // this.pageSizeCode = 10;
      if (searchData.seekstartDate && searchData.seekstartDate.length) {
        searchData.startSeekStartTime = searchData.seekstartDate[0];
        searchData.endSeekStartTime = searchData.seekstartDate[1];
      }
      if (searchData.seekendDate && searchData.seekendDate.length) {
        searchData.startSeekOffTime = searchData.seekendDate[0];
        searchData.endSeekOffTime = searchData.seekendDate[1];
      }
      delete searchData.seekstartDate;
      delete searchData.seekendDate;

      this.formDataSearch = searchData;
      this.getList(this.formDataSearch);
    },
    resetForm() {
      this.formData = {};
      this.formData.pageNo = 1;
    },
    // 查看
    cellClick(row, column) {
      if (["skuId"].includes(column.property)) {
        // this.goDetail(row)
      }
    },
    // 根据返回状态显示不同的文字颜色
    cellStyle({ column }) {
      if (["skuId"].includes(column.property)) {
        // return { color: '#0089EF', cursor: 'pointer' }
      }
    },
    // 表格宽度更改存入
    tableTitleWidth(newWidth, oldWidth, column) {
      for (let i = 0; i < this.unfixedTableThead.length; i++) {
        if (this.unfixedTableThead[i].label === column.label) {
          this.unfixedTableThead[i].width = newWidth;
        }
      }
      this.tableThead = this.unfixedTableThead.concat(this.fixedTableThead);
      const comment = JSON.stringify(this.tableThead);
      localStorage.setItem(this.tableName, comment);

      this.tableTheadOptions = JSON.parse(localStorage.getItem(this.tableName));
      this.tableHack = false;
      this.$nextTick(() => {
        this.tableHack = true;
      });
    },
    handleSelectionChange(rows) {
      this.tableSelectLists = rows;
    },
    getLocalPageSize() {
      return getSessionItem("pageSize", this.tableList.inventoryInbound) || 10;
    },
    // 当前页码更改
    handleCurrentChange(val) {
      // 跳转翻页都会调这个方法
      this.formDataSearch.pageNo = val;
      this.getList(this.formDataSearch);
    },
    handlePrev() {},
    // 下一页
    handleNext() {},
    handleSizeChange(val) {
      this.formDataSearch.pageNo = 1;
      this.formDataSearch.pageSize = val;
      // setSessionItem("pageSize", this.tableName, val);
      this.getList(this.formDataSearch);
    },
    filteredOptions(row) {
      console.log("🚀 ~ filteredOptions ~ row:", row.quoteType);
      const optionsMap = {
        1: [this.options[0]],
        2: [
          // 询价截止前，报价结果为空，支持【再次报价】操作
          !row.isOff ? this.options[2] : this.options[1]
        ],
        3: [this.options[1]]
      };
      return optionsMap[row.quoteType] || [];
    },
    handleClick(row, value) {
      this.$emit("handleClick", row, value);
    },
    getList(data) {
      this.$emit("child-event", data);
    }
  }
};
</script>
<style lang="scss" scoped>
.tab {
  margin-right: 15px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
}
/deep/.el-button + .el-button,
.el-checkbox.is-bordered + .el-checkbox.is-bordered {
  margin-left: 15px;
}
.top {
  margin-bottom: 20px;
}
/deep/.el-search .el-searchs {
  margin-top: -30px;
}
/deep/.el-search {
  overflow: inherit !important;
}
.isSelect {
  background: #47b548;
  color: white;
  padding: 0 4px;
  display: inline-block;
  font-size: 12px;
  margin-left: 8px;
  height: 16px;
  line-height: 16px;
  border-radius: 2px;
}
.unIsSelect {
  display: inline-block;
  background: #ff4e62;
  color: white;
  padding: 0 4px;
  font-size: 12px;
  margin-left: 8px;
  height: 16px;
  line-height: 16px;
  border-radius: 2px;
}
/deep/ .el-searchs-box {
  .el-date-editor.el-range-editor.el-input__inner.el-date-editor--daterange {
    border: none;
  }
}
</style>
